import { Box, Grid } from '@material-ui/core'
import Button from 'presentation/shared/components/Button'
import Heading from 'presentation/shared/components/Heading'
import SupportText from 'presentation/shared/components/SupportText'
import React from 'react'
import PhoneIcon from '@material-ui/icons/PhoneRounded'
import MailIcon from '@material-ui/icons/MailRounded'
import theme from 'presentation/styles/theme'
import { useFormikContext } from 'formik'
import { EmergencyRoomEditFormikValues } from 'presentation/hospital/layouts/EmergencyRoom/EmergencyRoomDetails/types'
import { EmergencyRoomAttendanceModel } from 'domain/entities/emergency-room-attendance.model'

type EmergencyRoomCardDetailsProps = {
  emergencyRoom?: EmergencyRoomAttendanceModel
}

export function EmergencyRoomCardDetails({
  emergencyRoom
}: EmergencyRoomCardDetailsProps) {
  const { values, setFieldValue } =
    useFormikContext<EmergencyRoomEditFormikValues>()
  const { isEditing } = values

  const handleSetEdit = () => {
    setFieldValue('isEditing', true)
  }
  return (
    <Box
      p={2}
      bgcolor={theme.colors.white}
      borderRadius={theme.border.radius.medium}
      width="100%"
    >
      <Grid container spacing={2}>
        <Grid
          container
          item
          xs={12}
          justifyContent="space-between"
          alignItems="center"
        >
          <SupportText color="primary">
            {emergencyRoom?.specialty || '-'}
          </SupportText>
          {!isEditing && (
            <Button
              variant="outlined"
              onClick={handleSetEdit}
              style={{ width: '173px' }}
            >
              Editar
            </Button>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          <Heading size="xlarge" color="primary">
            {values.updatePatient?.name || '...'}
          </Heading>
        </Grid>
        <Grid container item xs={12} alignItems="center">
          <Box display="flex" alignItems="center" gridColumnGap="0.5rem">
            <PhoneIcon style={{ color: theme.colors.primary }} />
            <SupportText color="lightGray">
              {values.updatePatient?.phone || '-'}
            </SupportText>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            gridColumnGap="0.5rem"
            marginLeft={1}
          >
            <MailIcon style={{ color: theme.colors.primary }} />
            <SupportText color="lightGray">
              {values.updatePatient?.email || '-'}
            </SupportText>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
